import React from "react";
import Link from "next/link";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { FormSectionProps } from "./types";

const PrivacyPolicySection: React.FC<FormSectionProps> = ({
  setValue,
  watchedFields,
  errors,
}) => {

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-lg">Privacy & Policy Agreement</h3>
      <div className="space-y-4">
        <div className="flex items-start space-x-3" data-question-field="acceptedTermsOfService">
          <Checkbox
            id="privacyPolicyAgreement"
            checked={
              (watchedFields.acceptedTermsOfService &&
                watchedFields.acceptedPrivacyPolicy &&
                watchedFields.acceptedCookiePolicy) || false
            }
            onCheckedChange={(checked) => {
              const isChecked = checked as boolean;
              setValue("acceptedTermsOfService", isChecked);
              setValue("acceptedPrivacyPolicy", isChecked);
              setValue("acceptedCookiePolicy", isChecked);
            }}
            className="mt-1"
          />
          <Label htmlFor="privacyPolicyAgreement" className="font-normal cursor-pointer flex-1 text-black leading-relaxed text-neutral-500">
            I consent to World Class Design storing and processing my personal data for hiring, talent matching, and portfolio review purposes until I request deletion, as described in the{" "}
            <Link
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Privacy Policy
            </Link>
            .
          </Label>
        </div>
        {(errors.acceptedTermsOfService || errors.acceptedPrivacyPolicy || errors.acceptedCookiePolicy) && (
          <p className="text-sm text-red-500 ml-7">
            You must accept the Privacy & Policy Agreement to continue.
          </p>
        )}

        <div className="bg-gray-100 rounded-lg p-4 space-y-2 text-gray-500 text-xs">
          <p>
            <span className="font-medium">1. Why we collect this data:</span> We use this to evaluate your profile for founder searches Guidione runs, portfolio review, and future design opportunities you opt into.
          </p>
          <p>
            <span className="font-medium ">2. Who can access it:</span> Only Guidione and the World Class Design hiring team.
          </p>
          <p>
            <span className="font-medium">3. How long we keep it:</span> Your data is stored indefinitely unless you request deletion sooner.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicySection;

